import { decode } from 'jsonwebtoken'

export const getExpireIn = token => {
  if (!token) return null

  const jwt = decode(token)

  return jwt ? jwt.exp : 0
}
